import * as s from "fp-ts/lib/Either";
import { pipe as o } from "fp-ts/lib/function";
const p = (e, a, t) => o(
  a.safeParse(e, t),
  (r) => r.success ? s.right(r.data) : (
    // @ts-ignore -- this shows up as a type error when compiling the docs
    s.left(r.error)
  )
);
export {
  p as s
};
//# sourceMappingURL=safeParse-DnG_XuKZ.mjs.map
